import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import {
  FIRST_NAME_SCHEMA,
  LAST_NAME_SCHEMA,
  PHONE_SCHEMA,
  EMAIL_SCHEMA,
} from 'typescript/schemas/address_forms/common';
import { CountryCode } from 'typescript/constants/localization';

const usePickupPersonForm = ({ countryCode }: { countryCode: CountryCode }) => {
  const pickupPersonSchema = useMemo(
    () =>
      z.object({
        pickup_first_name: FIRST_NAME_SCHEMA,
        pickup_last_name: LAST_NAME_SCHEMA,
        pickup_email: EMAIL_SCHEMA,
        pickup_phone: PHONE_SCHEMA(countryCode),
      }),
    [],
  );

  const formMethods = useForm({
    mode: 'onBlur',
    resolver: zodResolver(pickupPersonSchema),
  });

  return {
    pickupPersonSchema,
    formMethods,
  };
};

export default usePickupPersonForm;
